import {
  CATEGORY_FILTER_CHANGE,
  COPY_SCENARIO_ASYNC,
  CREATE_CAMPAIGN_FROM_SCENARIO_ASYNC,
  CREATED_BY_FILTER_CHANGE,
  DELETE_SCENARIO_ASYNC,
  LANGUAGES_FILTER_CHANGE,
  LEVEL_FILTER_CHANGE,
  PAGINATE_CHANGE,
  SCENARIOS_REQUEST_ASYNC,
  SEARCH_CHANGE,
  SEARCH_RESET,
  SORT_PROPERTY_CHANGE,
  TYPE_FILTER_CHANGE,
} from './constants'

export const fetchScenarios = (isClearMessage = true) => ({
  type: SCENARIOS_REQUEST_ASYNC.INITIATE,
  payload: { isClearMessage },
})
export const fetchScenariosSuccess = (data) => ({
  type: SCENARIOS_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
const fetchScenariosCancel = () => ({ type: SCENARIOS_REQUEST_ASYNC.CANCEL })
export const fetchScenariosError = (error) => ({
  type: SCENARIOS_REQUEST_ASYNC.ERROR,
  error,
})

const languagesFilterChange = (languagesArray) => ({
  type: LANGUAGES_FILTER_CHANGE,
  payload: { languagesArray },
})
const typeFilterChange = (typeArray) => ({
  type: TYPE_FILTER_CHANGE,
  payload: { typeArray },
})
const levelFilterChange = (levelArray) => ({
  type: LEVEL_FILTER_CHANGE,
  payload: { levelArray },
})
const categoryFilterChange = (arr) => ({
  type: CATEGORY_FILTER_CHANGE,
  payload: { arr },
})
const changeCreatedByFilter = (array) => ({
  type: CREATED_BY_FILTER_CHANGE,
  payload: { array },
})

const paginateChange = (page) => ({ type: PAGINATE_CHANGE, payload: { page } })
const searchChange = (q) => ({ type: SEARCH_CHANGE, payload: { q } })
const searchReset = () => ({ type: SEARCH_RESET })

export const deleteScenario = (id) => ({
  type: DELETE_SCENARIO_ASYNC.INITIATE,
  payload: { id },
})
export const deleteScenarioSuccess = () => ({
  type: DELETE_SCENARIO_ASYNC.SUCCESS,
})
export const deleteScenarioError = (error) => ({
  type: DELETE_SCENARIO_ASYNC.ERROR,
  error,
})

export const createNewCampaignFromScenario = (id) => ({
  type: CREATE_CAMPAIGN_FROM_SCENARIO_ASYNC.INITIATE,
  payload: { id },
})
export const createNewCampaignFromScenarioSuccess = ({ response }) => ({
  type: CREATE_CAMPAIGN_FROM_SCENARIO_ASYNC.SUCCESS,
  response,
})
export const createNewCampaignFromScenarioError = (error) => ({
  type: CREATE_CAMPAIGN_FROM_SCENARIO_ASYNC.ERROR,
  error,
})

export const copyScenario = (id, companiesIds, copyName) => ({
  type: COPY_SCENARIO_ASYNC.INITIATE,
  payload: { id, companiesIds, copyName },
})
export const copyScenarioSuccess = () => ({ type: COPY_SCENARIO_ASYNC.SUCCESS })
export const copyScenarioError = (error) => ({
  type: COPY_SCENARIO_ASYNC.ERROR,
  error,
})

const sortPropertyChange = (value) => ({
  type: SORT_PROPERTY_CHANGE,
  payload: { value },
})

export default {
  // to props
  fetchScenarios,
  fetchScenariosCancel,
  languagesFilterChange,
  typeFilterChange,
  levelFilterChange,
  changeCreatedByFilter,
  categoryFilterChange,
  paginateChange,
  searchChange,
  searchReset,
  deleteScenario,
  createNewCampaignFromScenario,
  sortPropertyChange,
}
